<template>
    <div class="d-calendar__timelist">
        <div class="d-calendar__timecell" v-for="time in times">
            <span v-html="time.format('HH:mm')"></span>
        </div>
    </div>
</template>

<script>
	import {mapGetters} from 'vuex';

    export default {
    	name: 'CalendarTime',
		computed: {
			...mapGetters([
				'times',
			]),
		},
    }
</script>

